module.exports = __webpack_public_path__ + "img/lead_icon.93ffa8a5.png";